/* eslint-disable prettier/prettier */
import { apiUrls } from '@http/api-urls'
import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { NextPageFC } from '@shared/models/next-fc'
import { httpAdminService } from 'admin/http'
import { PageConfig } from 'admin/types'
import { GetServerSideProps } from 'next'
import { Sitemap } from 'screens/sitemap'
import { serverSideResolveCity } from 'ssr-resolvers/next-ssr-resolvers'

const SitemapPage: NextPageFC<{ pagesFromAdminPanel: PageConfig[] }, PageLayoutOwnProps> = ({
	pagesFromAdminPanel,
}) => Sitemap({ isRegional: true, pagesFromAdminPanel })

SitemapPage.layout = PageLayout

SitemapPage.headProps = {
	title: 'Карта сайта - %city_im%',
	description: 'Перечень всех страниц сайта. %city_im%. Credit.Club.',
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	const resolveCityProps = (await serverSideResolveCity(context)) as { props: any }
	const pagesFromAdminPanel: PageConfig = await httpAdminService.get(apiUrls.getAdminPages())

	return { props: { ...resolveCityProps.props, pagesFromAdminPanel } }
}

export default SitemapPage
